import axios from 'axios'

export default class AutoComplete {
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...AutoComplete.prototype.defaults, ...options }
        this.init()
    }

    clear() {
        if (this.timeoutHide) {
            clearTimeout(this.timeoutHide)
        }

        this.DOM.$results.innerHTML = ''
        this.DOM.$results.scrollTop = 0
        this.results = []
        this.selectedIndex = null
    }

    init() {
        this.data = {
            id: this.DOM.$el.dataset.autocompleteId,
            init: this.DOM.$el.dataset.autocompleteInit || '',
            key: this.DOM.$el.dataset.autocompleteKey,
            keyDisplay: this.DOM.$el.dataset.autocompleteKeyDisplay,
            minLength: this.DOM.$el.dataset.autocompleteMinLength || 3,
            url: this.DOM.$el.dataset.autocompleteUrl,
        }

        this.DOM.$selected = document.getElementById(`${this.data.id}-selected`)
        this.DOM.$template = document.getElementById(`${this.data.id}-template`)
        this.DOM.$templateFooter = document.getElementById(`${this.data.id}-footer`)
        this.DOM.$templateNoResults = document.getElementById(`${this.data.id}-noResults`)

        this.cancelTokenSource = null
        this.param = name
        this.results = []
        this.selectedIndex = null
        this.template = _.template(this.DOM.$template.innerHTML)
        this.timeoutHide = null

        this.DOM.$el.addEventListener("focusout", this.validateInputWithResult.bind(this))

        if (this.data.url) {
            this.DOM.$el.classList.add(this.options.classNameInput)
            this.DOM.$el.setAttribute('autocomplete', 'off')

            // Add wrapper
            this.DOM.$wrapper = document.createElement('div')
            this.DOM.$wrapper.classList.add(this.options.className)
            this.DOM.$wrapper.style.position = 'relative'
            this.DOM.$el.parentNode.insertBefore(this.DOM.$wrapper, this.DOM.$el)
            this.DOM.$wrapper.appendChild(this.DOM.$el)

            // Add result container
            this.DOM.$results = document.createElement('div')
            this.DOM.$results.classList.add(this.options.classNameResults)
            this.DOM.$wrapper.appendChild(this.DOM.$results)

            // Register listeners
            this.DOM.$el.addEventListener('blur', this.onBlur.bind(this))
            this.DOM.$el.addEventListener('keyup', _.debounce(this.onKeyUp.bind(this), 100))
            this.DOM.$el.addEventListener('keydown', this.onKeyDown.bind(this))

            // Fetch first result for pre-filled value
            if (this.data.init.trim() !== '') {
                const q = this.data.init.trim()
                const url = this.data.url.replace('%q', q)

                this.request = axios.get(url)
                    .then(results => results.data)
                    .then(results => {
                        this.results = results
                        this.select(0)
                    })
            }
        }
    }

    validateInputWithResult() {
        if (this.DOM.$selected && this.DOM.$el.value !== this.DOM.$selected.value) {
            this.DOM.$el.value = ''
        }
    }

    onBlur() {
        this.timeoutHide = setTimeout(this.clear.bind(this), 250)
    }

    onKeyDown(e) {
        if (e.key === 'ArrowDown') {
            e.preventDefault()
            return this.updateSelection(1)
        }

        if (e.key === 'ArrowUp') {
            e.preventDefault()
            return this.updateSelection(-1)
        }

        if (e.key === 'Enter') {
            e.preventDefault()
            this.select(this.selectedIndex)
        }
    }

    onKeyUp(e) {
        const q = this.DOM.$el.value.trim()
        const url = this.data.url.replace('%q', q)

        if (['ArrowDown', 'ArrowUp', 'Enter'].indexOf(e.key) !== -1) {
            return
        }

        if (this.q !== q) {
            if (q.length >= this.data.minLength) {
                this.DOM.$wrapper.classList.add(this.options.classNameIsLoading)

                // Get Axios cancel token
                const CancelToken = axios.CancelToken
                const cancelTokenSource = CancelToken.source()

                // Cancel pending requests
                if (this.cancelTokenSource) {
                    this.cancelTokenSource.cancel()
                }

                this.cancelTokenSource = cancelTokenSource

                // Prepare footer
                let $footer = document.createElement('footer')
                $footer.classList.add(this.options.classNameFooter)

                axios.get(url, { cancelToken: cancelTokenSource.token })
                    .then(results => results.data)
                    .then(results => {
                        this.DOM.$results.innerHTML = ''
                        this.results = results
                        this.selectedIndex = null

                        if (results.length) {
                            results.forEach((result, i) => {
                                // Create result
                                let $result = document.createElement('div')
                                $result.addEventListener('click', this.onResultClick.bind(this))
                                $result.classList.add(this.options.classNameResult)
                                $result.dataset.index = i
                                $result.innerHTML = this.template(result)

                                // Add result to list
                                this.DOM.$results.appendChild($result)
                            })

                            if (this.DOM.$templateFooter) {
                                $footer.innerHTML = this.DOM.$templateFooter.innerHTML
                            }
                        } else {
                            // No results
                            if (this.DOM.$templateNoResults) {
                                $footer.innerHTML = this.DOM.$templateNoResults.innerHTML
                            }
                        }

                        if (this.DOM.$templateFooter) {
                            this.DOM.$results.appendChild($footer)
                        }
                        this.DOM.$wrapper.classList.remove(this.options.classNameIsLoading)
                    })
                    .catch(exception => {
                        this.DOM.$results.innerHTML = ''

                        // No results
                        if (this.DOM.$templateNoResults) {
                            $footer.innerHTML = this.DOM.$templateNoResults.innerHTML
                            
                        }

                        this.DOM.$results.appendChild($footer)
                        this.DOM.$wrapper.classList.remove(this.options.classNameIsLoading)
                    })
            } else {
                this.clear()
            }

            this.q = q
        }
    }

    onResultClick(e) {
        if (this.timeoutHide) {
            clearTimeout(this.timeoutHide)
        }

        this.select(parseInt(e.currentTarget.dataset.index, 10))
    }

    select(index) {
        const $selected = this.DOM.$results.children[index]
        const result = this.results[index]

        this.DOM.$el.blur()
        this.DOM.$el.value = result[this.data.keyDisplay]
        if (this.DOM.$selected) {
            this.DOM.$selected.value = result[this.data.keyDisplay]
        }

        this.DOM.$el.dispatchEvent(new CustomEvent('autocomplete:select', {
            bubbles: true,
            detail: result,
        }))

        if ($selected) {
            $selected.addEventListener('animationend', this.clear.bind(this), { once: true })
            $selected.classList.add(this.options.classNameIsSelected)
        }
    }

    updateSelection(direction) {
        if (this.results.length) {
            const maxIndex = this.results.length - 1
            const resultsHeight = this.DOM.$results.offsetHeight

            if (this.selectedIndex === null) {
                this.selectedIndex = 0
            } else {
                this.selectedIndex += direction
                this.selectedIndex = (this.selectedIndex < 0) ? 0 : this.selectedIndex
                this.selectedIndex = (this.selectedIndex > maxIndex) ? maxIndex : this.selectedIndex
            }

            // Deselect all
            Array.from(this.DOM.$results.children).forEach($el => {
                $el.classList.remove(this.options.classNameIsHighlighted, this.options.classNameIsSelected)
            })

            // Select current
            const $selected = this.DOM.$results.children[this.selectedIndex]
            let selectedBottom = 0

            if (this.selectedIndex === maxIndex) {
                const $lastChild = this.DOM.$results.lastChild
                selectedBottom = $lastChild.offsetTop + $lastChild.offsetHeight
            } else {
                selectedBottom = $selected.offsetTop + $selected.offsetHeight
            }

            $selected.classList.add(this.options.classNameIsHighlighted)

            if (selectedBottom > resultsHeight) {
                this.DOM.$results.scrollTop = selectedBottom - resultsHeight
            } else {
                this.DOM.$results.scrollTop = 0
            }

            // Update UI
            this.DOM.$el.select()
        }
    }
}

AutoComplete.prototype.defaults = {
    className: 'c-autoComplete',
    classNameFooter: 'c-autoComplete__footer',
    classNameInput: 'c-autoComplete__input',
    classNameIsHighlighted: 'is-highlighted',
    classNameIsLoading: 'is-loading',
    classNameIsSelected: 'is-selected',
    classNameResult: 'c-autoComplete__result',
    classNameResults: 'c-autoComplete__results',
}